<template>
  <div>
    <div style="display: flex;justify-content: space-between;">
      <div style="display: flex;">
        <div style="margin-top:15px">效果图:</div>
        <img
          :src="peitu"
          width="50px"
          @click="dialogVisible = true"
          height="50px"
        />
        <el-dialog title="效果图" :visible.sync="dialogVisible">
          <img :src="peitu" width="100%" height="100%" />
        </el-dialog>
      </div>
    </div>
    <el-form ref="data" :model="data" label-width="80px">
      <el-form-item label="上传图片">
        <el-upload
          class="avatar-uploader"
          action="/api/file/upload"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          name="uploadFile"
        >
          <img v-if="data.aboutImg" :src="data.aboutImg" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="文字描述">
        <ckeditor
          style="line-height: 20px;width:80%"
          :editor="editor"
          v-model="data.aboutContent"
          :config="editorConfig"
        ></ckeditor>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  data() {
    return {
      data: { aboutImg: "", aboutContent: "" },
      editor: ClassicEditor,
      editorConfig: {
        removePlugins: ["MediaEmbed"], //除去视频按钮
        language: "zh-cn", //中文包
        toolbar: [
          "heading", //段落
          "|", //分隔
          "bold", //加粗
          "italic", //倾斜
          "link", //超链接
          "bulletedList", //项目列表
          "numberedList", //编号列表
          "blockQuote", //块引用
          "undo", //撤销
          "redo" //重做
        ] //工具栏显示
      },
      dialogVisible: false,
      peitu: require("@/assets/logo.png")
    };
  },
  props: {
    openModule: {
      default: []
    }
  },
  mounted() {
    this.getMassage();
  },
  watch: {
    data: {
      handler(val) {
        console.log("1111111111111321", val);
        this.$emit("getModule", val);
      },
      deep: true
    },
    openModule: {
      handler(val) {
        console.log("1`23123321", val);
        this.getMassage();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getMassage() {
      if (this.openModule) {
        if (this.openModule[0].aboutImg) {
          this.data.aboutImg = this.openModule[0].aboutImg;
        } else {
          this.data.aboutImg = false;
        }
        if (this.openModule[0].aboutContent) {
          this.data.aboutContent = this.openModule[0].aboutContent;
        } else {
          this.data.aboutContent = "";
        }
      }
    },
    handleAvatarSuccess(res) {
      this.data.aboutImg = res.data.fileurl;
    }
  }
};
</script>

<style lang="sass" scoped>
.avatar-uploader .el-upload
  border: 1px dashed #d9d9d9
  border-radius: 6px
  cursor: pointer
  position: relative
  overflow: hidden
.avatar-uploader .el-upload:hover
  border-color: #409EFF
.avatar-uploader-icon
  font-size: 28px
  color: #8c939d
  width: 178px
  height: 178px
  line-height: 178px
  text-align: center
.avatar
  width: 178px
  height: 178px
  display: block
</style>
